/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, displayTypes, replacePXinStringWithEM, embedCorners } from 'utils/styles';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// LAYOUT STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default {
	layout: {
		position: 'relative',
		height: '100%',
		width: '100%',
		margin: '0 auto',
		background: "radial-gradient(ellipse at center, rgba(82,83,84,0.85) 0%, rgba(0,10,10,0.9) 100%)", // added so when we move from content to content there is less jarring transition
		overflow: 'auto',
		extend: embedCorners // late design addition to differentiate the unit from an ad
	}
};
